// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__9hkzD","text_container":"Loader_text_container__+1ovh","jump":"Loader_jump__5ROgL","bounce":"Loader_bounce__fzMSD","filler":"Loader_filler__H7yRN"};